import { useEffect, useState } from 'react';

import { pipelineApi } from '../../api/pipeline.js';

const POLL_MS = 5000;

// Poll a single pipeline run until it's terminal.
// `onTerminal({status, error?})` fires once when the run finishes.
// Returns `{ status, runId, start, reset }`. Call `start(runId)` after
// kicking off a pipeline; `reset()` to clear UI state.
export function usePipelinePoll(onTerminal) {
  const [runId, setRunId]   = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!runId) return undefined;
    let cancelled = false;
    let timer = null;

    async function tick() {
      try {
        const next = await pipelineApi.getStatus(runId);
        if (cancelled) return;
        setStatus(next);
        if (next.status === 'succeeded' || next.status === 'failed') {
          onTerminal?.(next);
          return;
        }
        timer = setTimeout(tick, POLL_MS);
      } catch (e) {
        if (cancelled) return;
        onTerminal?.({ status: 'failed', error: e.message });
      }
    }
    tick();
    return () => { cancelled = true; if (timer) clearTimeout(timer); };
  }, [runId, onTerminal]);

  return {
    status, runId,
    start: setRunId,
    reset: () => { setStatus(null); setRunId(null); },
  };
}
